import { create } from 'zustand';

interface AppHealthState {
  catalogSyncError: string | null;
  cartHydrationError: string | null;
  locationHydrationError: string | null;
  shiftHydrationError: string | null;
  /** T17: a key rotation found unsynced bills and delayed the local wipe. */
  deviceKeyWarning: string | null;
  /** T17: the browser refused persistent storage for the offline queue. */
  storageWarning: string | null;

  setCatalogSyncError: (error: string | null) => void;
  setCartHydrationError: (error: string | null) => void;
  setLocationHydrationError: (error: string | null) => void;
  setShiftHydrationError: (error: string | null) => void;
  setDeviceKeyWarning: (warning: string | null) => void;
  setStorageWarning: (warning: string | null) => void;
  clearAll: () => void;
}

export const useAppHealthStore = create<AppHealthState>((set) => ({
  catalogSyncError: null,
  cartHydrationError: null,
  locationHydrationError: null,
  shiftHydrationError: null,
  deviceKeyWarning: null,
  storageWarning: null,

  setCatalogSyncError: (error) => set({ catalogSyncError: error }),
  setCartHydrationError: (error) => set({ cartHydrationError: error }),
  setLocationHydrationError: (error) => set({ locationHydrationError: error }),
  setShiftHydrationError: (error) => set({ shiftHydrationError: error }),
  setDeviceKeyWarning: (warning) => set({ deviceKeyWarning: warning }),
  setStorageWarning: (warning) => set({ storageWarning: warning }),
  clearAll: () => set({
    catalogSyncError: null,
    cartHydrationError: null,
    locationHydrationError: null,
    shiftHydrationError: null,
  }),
}));
